import { Controller } from "stimulus";

export default class extends Controller {
  static targets = [
    "limitCountContainer",
    "limitCountInput",
    "leadValueInput",
    "leadUnitInput"
  ]

  connect() {
    this.toggleLimitCount();
  }

  toggleLimitCount(event) {
    if (event && event.target && event.target.name !== "student_schedule_make_up_limit") {
      return;
    }

    const selected = this.element.querySelector('input[name="student_schedule_make_up_limit"]:checked');
    const isLimitEnabled = selected && selected.value === "1";

    this.limitCountContainerTarget.style.display = isLimitEnabled ? "" : "none";
    this.limitCountInputTarget.disabled = !isLimitEnabled;

    if (!isLimitEnabled) {
      this.limitCountInputTarget.value = "";
    }

    this.limitCountInputTarget.setCustomValidity("");
  }

  validateForm(event) {
    if (!this.validateLeadLimit(event)) {
      return;
    }

    const selected = this.element.querySelector('input[name="student_schedule_make_up_limit"]:checked');
    const isLimitEnabled = selected && selected.value === "1";

    if (!isLimitEnabled) {
      this.limitCountInputTarget.setCustomValidity("");
      return;
    }

    const count = Number(this.limitCountInputTarget.value);
    const isInvalid = this.limitCountInputTarget.value === "" || Number.isNaN(count) || count <= 0;

    if (isInvalid) {
      event.preventDefault();
      this.limitCountInputTarget.setCustomValidity("Limit count is required when limiting sessions is enabled");
      this.limitCountInputTarget.reportValidity();
      return;
    }

    this.limitCountInputTarget.setCustomValidity("");
  }

  validateLeadLimit(event) {
    const rawValue = this.leadValueInputTarget.value;
    const value = Number(rawValue);

    if (rawValue === "" || Number.isNaN(value) || value <= 0) {
      event.preventDefault();
      this.leadValueInputTarget.setCustomValidity("Value must be greater than 0");
      this.leadValueInputTarget.reportValidity();
      return false;
    }

    this.clearLeadValidation();
    return true;
  }

  clearLimitCountValidation() {
    this.limitCountInputTarget.setCustomValidity("");
  }

  clearLeadValidation() {
    this.leadValueInputTarget.setCustomValidity("");
  }
}
